// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluatePublicationFinderPage-cls1_WL9","cls2":"EvaluatePublicationFinderPage-cls2_4Dm EvaluatePublicationFinderPage-cls1_WL9"};